import { FC } from 'react';

import { ElementarySchoolError } from 'src/components/elementary-school-view/elementary-school-error';
import { MiddleSchoolError } from 'src/components/middle-school-view';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';

interface Props {
  withImage?: boolean;
  errorMessage?: string;
}

export const Error: FC<Props> = ({ withImage = true, errorMessage }) => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  if (isMiddleSchoolView) {
    return <MiddleSchoolError withImage={withImage} />;
  }

  return (
    <ElementarySchoolError withImage={withImage} errorMessage={errorMessage} />
  );
};
